import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.string.starts-with";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from '../../../services/apiService';
import { mapState } from 'vuex'; // Map roleId to `DigitalTwin.DigitalTwin` i18n key
// Handled like this so roleIds can be read from DB later

var roleIdToNameMap = {
  0: '0',
  1: '1'
};
export default {
  name: 'CoreDtwinUserRelations',
  props: {
    scopeId: {
      type: Number,
      required: true
    },
    twinDataRelations: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    isOpen: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      addUserRelationDialog: false,
      inputUserId: null,
      inputRoleId: null,
      search: null,
      formIsValid: false,
      storeEditRelation: {},
      twinDataUsers: [],
      selectRoleItems: [],
      userRelations: [],
      headers: [{
        text: this.$i18n_t('DigitalTwin.DigitalTwin.userRelationsTableName'),
        value: 'name',
        align: 'start'
      }, {
        text: this.$i18n_t('DigitalTwin.DigitalTwin.userRelationsTableRole'),
        value: 'role',
        align: 'start'
      }, {}, {}],
      tableFooterProps: {
        itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
        itemsPerPageOptions: [20, 50, {
          text: this.$i18n_t('Common.all'),
          value: -1
        }]
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['snackbar', 'inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme'])), {}, {
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    buttons: function buttons() {
      return [{
        title: this.$i18n_t('DigitalTwin.DigitalTwin.attachmentButtonAdd'),
        icon: 'fal fa-plus',
        action: 'addItem',
        valid: !this.disabled
      }];
    }
  }),
  mounted: function mounted() {
    this.resetForm();
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;

      // only fetch the first 200 users; to be figured out what to do for the other ones
      ApiService.fetchUsers([], ['ancestors'], [], 0, 200).then(function (users) {
        _this.twinDataUsers = users.users.map(function (user) {
          return {
            id: user.id,
            name: "".concat(user.firstName, " ").concat(user.lastName)
          };
        });
        _this.userRelations = _this.mapNamesToRelations(_this.twinDataRelations);
        _this.selectRoleItems = _this.createSelectRoleItems();
      }).catch(function (error) {
        console.error(error);
      });
    },
    addItem: function addItem() {
      this.$refs.attachmentInput.click();
    },
    mapNamesToRelations: function mapNamesToRelations(relationData) {
      var _this2 = this;

      return relationData.map(function (item) {
        var userObject = _this2.findUserById(item.userId);

        return {
          userId: userObject.id,
          roleId: item.roleId,
          name: userObject.name,
          role: _this2.findRoleNameById(item.roleId)
        };
      }) // Filter out users without userId, that would be those that were
      // listed in the user/twin relations but do not exist in allowed users
      // for the twin. (Users that are deleted or lost access in the meantime)
      .filter(function (item) {
        return !!item.userId;
      });
    },
    createSelectRoleItems: function createSelectRoleItems() {
      var _this3 = this;

      return Object.keys(roleIdToNameMap).map(function (roleId) {
        return {
          roleId: parseInt(roleId, 10),
          role: _this3.$i18n_t("DigitalTwin.DigitalTwin.userRelationsRoles.".concat(roleIdToNameMap[roleId]))
        };
      });
    },
    findUserById: function findUserById(userId) {
      var userObject = this.twinDataUsers.slice(0).filter(function (user) {
        return user.id === userId;
      });
      return userObject.length > 0 ? userObject[0] : {};
    },
    findRoleNameById: function findRoleNameById(roleId) {
      var i18nRole = this.$i18n_t("DigitalTwin.DigitalTwin.userRelationsRoles.".concat(roleIdToNameMap[roleId]));

      if (i18nRole.startsWith('DigitalTwin.DigitalTwin.userRelationsRoles')) {
        // If no i18n string for the roleId could be found, fall back to error message
        return this.$i18n_t('DigitalTwin.DigitalTwin.userRelationsRolesUnknown');
      }

      return i18nRole;
    },
    resetForm: function resetForm() {
      this.search = null;
      this.inputUserId = null;
      this.inputRoleId = null;
      this.formIsValid = false;
      this.storeEditRelation = {};
    },
    openAddUserRelationDialog: function openAddUserRelationDialog() {
      this.resetForm();
      this.addUserRelationDialog = true;
    },
    closeAddUserRelationDialog: function closeAddUserRelationDialog() {
      this.addUserRelationDialog = false;
    },
    validateForm: function validateForm() {
      if (!this.inputUserId) {
        this.search = null;
      }

      this.formIsValid = Boolean(this.inputUserId) && !isNaN(parseInt(this.inputRoleId, 10));
    },
    updateUserRelation: function updateUserRelation(userId, roleId) {
      var _this4 = this;

      this.openAddUserRelationDialog();
      this.$nextTick(function () {
        _this4.storeEditRelation = {
          userId: userId,
          roleId: roleId
        };
        _this4.inputUserId = userId;
        _this4.inputRoleId = roleId;

        _this4.validateForm();
      });
    },
    deleteUserRelation: function deleteUserRelation(userId, roleId) {
      var newUserRelations = this.userRelations.filter(function (user) {
        return !(user.userId === userId && user.roleId === roleId);
      });
      var storeUserRelations = newUserRelations.map(function (user) {
        return {
          userId: user.userId,
          roleId: user.roleId
        };
      });
      this.userRelations = this.mapNamesToRelations(storeUserRelations);
      this.$emit('update', storeUserRelations);
    },
    isEntryDuplicated: function isEntryDuplicated(userId, roleId) {
      // Compare selected userid-roleId to existing entries in userRelations
      // to find if a combination already exists
      var foundDuplicates = this.userRelations.filter(function (item) {
        return item.userId === userId && item.roleId === roleId;
      });
      return foundDuplicates.length > 0;
    },
    handleSubmit: function handleSubmit() {
      var _this5 = this;

      this.closeAddUserRelationDialog(); // Check if entry already exists and if so show an error message

      if (this.isEntryDuplicated(this.inputUserId, this.inputRoleId)) {
        this.$snack(this.$i18n_t('DigitalTwin.DigitalTwin.userRelationErrorDuplicate'), 'error');
        return;
      } // Strip unwanted info from relations data


      var newRelations = this.userRelations.map(function (item) {
        return {
          userId: item.userId,
          roleId: item.roleId
        };
      });

      if (this.storeEditRelation.userId) {
        // replace onld entry with new one
        newRelations = newRelations.map(function (item) {
          var shouldUpdate = item.userId === _this5.storeEditRelation.userId && item.roleId === _this5.storeEditRelation.roleId;
          return {
            userId: shouldUpdate ? _this5.inputUserId : item.userId,
            roleId: shouldUpdate ? _this5.inputRoleId : item.roleId
          };
        });
      } else {
        // add new entry
        newRelations.push({
          userId: this.inputUserId,
          roleId: this.inputRoleId
        });
      }

      this.userRelations = this.mapNamesToRelations(newRelations);
      this.$emit('update', newRelations);
    }
  }
};